import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/sellers/market_products/orders/items'

const SellerMarketProductOrderItemsApiV2 = {
  /**
   * Get list of `Seller MarketProduct Order Item`
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Get single `Seller MarketProduct Order Item`
   * @param {number} id - Seller Market Product Order Item ID
   */
  show: async (id) => {
    const path = `${API_PATH}/${id}`

    const response = axios.get(path)
    return response
  },

  /**
   * Receive collection of `Seller MarketProduct Order Item`
   * @param {array} ids - collection of `Seller MarketProduct Order Item` Ids that want to receive
   */
  receive: async ({ ids }) => {
    const path = `${API_PATH}/receive`
    const body = {
      seller_market_product_order_item_ids: ids
    }

    const response = axios.patch(path, body)
    return response
  },

  /**
   * Accept a `Seller MarketProduct Order Item`
   * @param {array} id - `Seller MarketProduct Order Item` Id that want to acept
   */
  accept: async ({ id }) => {
    const path = `${API_PATH}/${id}/accept`

    const response = axios.patch(path)
    return response
  },

  /**
   * Reject a `Seller MarketProduct Order Item`
   * @param {array} ids -`Seller MarketProduct Order Item` Id that want to reject
   * @param {string} refund_reason - Refund Reason
   * @param {string} reject_reason_details - Reject Reason detail
   */
  reject: async ({ id, refund_reason, reject_reason_details }) => {
    const path = `${API_PATH}/${id}/reject`
    const body = {
      refund_reason         : refund_reason,
      reject_reason_details : reject_reason_details
    }

    const response = axios.patch(path, body)
    return response
  },

  update_courier: async ({ params }) => {
    const path = `${API_PATH}/update_courier`
    const body = {
      seller_market_product_order_item_ids : params.ids,
      courier                              : params.courier,
      tracking_number                      : params.tracking_number
    }

    const response = axios.patch(path, body)
    return response
  }
}

export default SellerMarketProductOrderItemsApiV2
